import { TooltipProvider } from 'components/ui/tooltip';
import ThreadsAppErrorBoundary from 'pages/errorBoundary';
import React, { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import MicrosoftClarityProvider from 'modules/app/components/MicrosoftClarityProvider';
import { useAuth } from 'modules/auth/useAuth';
import { ScreenLoader } from 'ui';
import ReactGA from 'react-ga4';
import { ENV } from 'constants/env';
import { initializeGoogleTagManager } from 'modules/googleAnalytics/utils';
import { AuthenticatedWrapper as AuthenticatedRoutes } from 'routes/authenticated-wrapper';
import { UnauthenticatedRoutes } from 'routes/unauthenticated';

const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  const initialiseGoogleAnalytics = () => {
    if (ENV.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID) {
      ReactGA.initialize(ENV.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID);
    }
  };

  useEffect(() => {
    initializeGoogleTagManager();
    initialiseGoogleAnalytics();
  }, [ENV.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID, ENV.VITE_GOOGLE_TAG_MANAGER_ID]);

  if (isLoading) return <ScreenLoader />;

  return (
    <MicrosoftClarityProvider>
      <ThreadsAppErrorBoundary>
        <TooltipProvider>
          <BrowserRouter>
            <Suspense>
              {isAuthenticated ? <AuthenticatedRoutes /> : <UnauthenticatedRoutes />}
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </ThreadsAppErrorBoundary>
    </MicrosoftClarityProvider>
  );
};

export default App;
